import styled from "styled-components";

export const TextEllipsis = styled.h3`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;